var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6247_9165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43738 7.54188L1.03098 5.5752C0.372773 6.90531 3.90625e-05 8.40539 0 10.0002C0 11.573 0.376758 13.0757 1.04508 14.4176L4.43715 12.4592C4.10258 11.7058 3.91301 10.8749 3.91305 10.0002C3.91309 9.12563 4.10277 8.29496 4.43738 7.54188Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5595 2.45188C14.8021 0.923205 12.5056 -0.0016774 9.99301 2.28396e-06C6.55547 0.00230697 3.48727 1.75723 1.68457 4.44625L5.09375 6.41461C6.20238 4.90235 7.98594 3.91301 10 3.91305C11.4683 3.91309 12.8142 4.43793 13.8654 5.30762C14.1228 5.52047 14.4989 5.50098 14.7351 5.26485L16.5918 3.40817C16.8595 3.14043 16.8452 2.70031 16.5595 2.45188Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9313 8.84281C19.8923 8.51176 19.614 8.26117 19.2808 8.26117L11.0868 8.26074C10.7266 8.26074 10.4346 8.55273 10.4346 8.91293V11.5195C10.4346 11.8796 10.7266 12.1716 11.0868 12.1716H15.6785C15.2555 13.2724 14.5209 14.2186 13.5857 14.9065L15.536 18.2846C17.4991 16.9543 18.9918 14.9429 19.6492 12.5685C20.0066 11.2775 20.0709 10.0292 19.9313 8.84281Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4577 15.5617C11.7056 15.8968 10.8753 16.0869 9.99965 16.087C7.98328 16.087 6.20074 15.0976 5.09289 13.5859L1.69824 15.5459C3.48582 18.2084 6.51965 20 9.99957 20C11.5727 20 13.07 19.6154 14.4093 18.942L12.4577 15.5617Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6247_9165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBlack);
export default __webpack_public_path__ + "static/media/google-black.584a8c65219f09054e129b87e4b4dcf1.svg";
export { ForwardRef as ReactComponent };